<div fxLayoutAlign="center center" style="margin-top: 1em;">
  <div fxFlex="80" fxLayoutAlign="center center" fxLayoutGap="5%">
    <img src="/assets/i/family.jpg" fxFlex="50">
    <div fxFlex="50">
      <h2>Family Law</h2>
      <p>We can help you navigate the many difficulties of family law, including divorce, child custody arrangements, and child support. We know that these can be some of the most important and stressful legal disputes in your life, and will do everything we can to guide you through the process and achieve the best results.</p>
    </div>
  </div>
</div>
